import React from "react";
import "./index.scss";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { useSelector } from "react-redux";
import { selectors as imgSelector } from "../../../state/features/header";

const ShopnowBanners = (props: any) => {
     const { imgBaseUrlSelectors }: any = useSelector((state) => ({
    imgBaseUrlSelectors: imgSelector.imgbaseUrl(state),
  }));
  const imgUrl = imgBaseUrlSelectors;
    return (
        <Slider {...props.settings}>
            {props.sliderlist.map(
                (item: {
                    key: string | number;
                    img: any;
                    SubHeading: string;
                    heading: string;
                    subheading2: string;
                }, index: number) => (
                    <div className="bannerView" key={item.heading}>
                        <ul>
                            <li>
                                <div className="shopPromossion"><img src={item?.img} alt="bannerImg" className="bannerImg" /></div>
                            </li>
                            <li className="headingView">
                                <div className="heading">{item.heading}</div>
                            </li>
                        </ul>
                    </div>
                )
            )}
        </Slider>
    );
};

export default ShopnowBanners;
